var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMinimize = function SvgMinimize(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 33",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(0, -1, 1, 0, -0.0005, 32.9995)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1F1E3F",
    d: "M 14.119 13.823 L 8.549 14.033 L 15.67 6.91 C 16.03 6.551 16.029 5.964 15.67 5.605 C 15.312 5.246 14.725 5.246 14.366 5.605 L 7.243 12.727 L 7.431 7.137 C 7.445 6.629 7.046 6.192 6.538 6.178 C 6.028 6.166 5.598 6.558 5.586 7.066 L 5.298 14.984 C 5.293 15.239 5.384 15.487 5.566 15.67 C 5.749 15.852 5.996 15.943 6.251 15.937 L 14.176 15.657 C 14.684 15.643 15.089 15.213 15.069 14.711 C 15.051 14.195 14.627 13.811 14.118 13.823",
    transform: "matrix(0, -1, 1, 0, -0.017799, 21.255229)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1E3F",
    d: "M 18.86 19.009 L 24.43 18.799 L 17.307 25.923 C 16.949 26.281 16.709 27.162 17.067 27.521 C 17.427 27.88 18.253 27.586 18.612 27.227 L 25.734 20.105 L 25.546 25.695 C 25.533 26.203 25.93 26.64 26.439 26.654 C 26.948 26.666 27.379 26.274 27.391 25.766 L 27.678 17.848 C 27.685 17.593 27.593 17.345 27.411 17.163 C 27.228 16.98 26.98 16.889 26.726 16.895 L 18.801 17.175 C 18.293 17.189 17.888 17.619 17.908 18.122 C 17.927 18.637 18.351 19.022 18.86 19.009",
    transform: "matrix(0, -1, 1, 0, -0.00519, 44.573841)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1657 -912) translate(1657 912)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "9299knykzb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L32.999 0 32.999 33 0 33z",
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1E3F",
    d: "M6.199 1.904c-2.369 0-4.296 1.927-4.296 4.296v20.6c0 2.368 1.927 4.296 4.296 4.296H26.8c2.368 0 4.295-1.928 4.295-4.296V6.2c0-2.369-1.927-4.296-4.295-4.296H6.199zM26.8 33H6.199C2.78 33 0 30.218 0 26.8V6.2C0 2.781 2.78 0 6.199 0H26.8c3.419 0 6.199 2.781 6.199 6.2v20.6c0 3.418-2.78 6.2-6.199 6.2z",
    mask: "url(#9299knykzb)"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMinimize, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/minimize.871021b8.svg";
export { ForwardRef as ReactComponent };